import { init as menuMobile } from "./modules/menu-mobile";
import "./modules/tagline";
import "./modules/swiper";
import { tick } from "./modules/counter";

tick();
menuMobile();